import {
  addMediaFileAPI,
  checkConsequencesBeforeBlobDeleteAPI,
  checkConsequencesBeforeMediaDeleteAPI,
  createBlobAPI,
  deleteBlobAPI,
  deleteMediaFileAPI,
  deleteQuizAnswerAPI,
  deleteQuizQuestionAPI,
  editBlobAPI,
  getBlobsAPI,
  GETBlobsResponse,
  getMediaFilesAPI,
  GETMediaFilesResponse,
  getSingleBlobAPI,
  GETSingleBlobResponse,
  PATCHEditBlobReqBody,
  PATCHEditBlobResponse,
  POSTAddMediaFileReqBody,
  POSTAddMediaFileResponse,
  POSTCreateBlobReqBody,
  POSTCreateBlobResponse,
  PUTUpdateBlobProgressBody,
  PUTUpdateBlobProgressResponse,
  updateBlobProgressAPI
} from '@myme/api';
import { MediaBlobType, Pagination, sendRequest, transformPaginationToSearchParams, UUID } from '@myme/utils';

const getBlobIdRecord = (blobId: UUID) => ({
  key: 'blobId',
  value: blobId
});

/* **** POST **** /blobs-library */
export const createBlob = async (reqBody: POSTCreateBlobReqBody) =>
  sendRequest<POSTCreateBlobResponse, POSTCreateBlobReqBody>(createBlobAPI, {
    reqBody
  });

/* **** POST **** /media-library */
export const addMediaFile = async (form: FormData) =>
  sendRequest<POSTAddMediaFileResponse, POSTAddMediaFileReqBody>(addMediaFileAPI, {
    reqBody: form as unknown as POSTAddMediaFileReqBody
  });

/* **** DELETE **** /blobs-library/:blobId */
export const deleteBlob = async (blobId: UUID) =>
  sendRequest<null, null>(deleteBlobAPI, {
    args: [getBlobIdRecord(blobId)]
  });

/* **** DELETE **** /media-library/:fileId */
export const deleteMediaFile = async (fileId: UUID) =>
  sendRequest<null, null>(deleteMediaFileAPI, {
    args: [{ key: 'fileId', value: fileId }]
  });

/* **** DELETE **** /blobs-library/:blobId/questions/:questionId */
export const deleteQuizQuestion = async (blobId: UUID, questionId: UUID) =>
  sendRequest<null, null>(deleteQuizQuestionAPI, {
    args: [getBlobIdRecord(blobId), { key: 'questionId', value: questionId }]
  });

/* **** DELETE **** /blobs-library/:blobId/questions/:questionId */
export const deleteQuizAnswer = async (blobId: UUID, answerId: UUID) =>
  sendRequest<null, null>(deleteQuizAnswerAPI, {
    args: [getBlobIdRecord(blobId), { key: 'answerId', value: answerId }]
  });

/* **** GET **** /api/media-library/before-delete/:fileId */
export const checkConsequencesBeforeMediaDelete = async (fileId: UUID) =>
  sendRequest<{ mymes: string[] }, null>(checkConsequencesBeforeMediaDeleteAPI, {
    args: [{ key: 'fileId', value: fileId }]
  });

/* **** GET **** /api/blobs-library/before-delete/:blobId */
export const checkConsequencesBeforeBlobDelete = async (blobId: UUID) =>
  sendRequest<{ mymes: string[] }, null>(checkConsequencesBeforeBlobDeleteAPI, {
    args: [{ key: 'blobId', value: blobId }]
  });

/* **** PATCH **** /blobs-library/:blobId */
export const editBlob = async (blobId: UUID, reqBody: PATCHEditBlobReqBody) =>
  sendRequest<PATCHEditBlobResponse, PATCHEditBlobReqBody>(editBlobAPI, {
    reqBody,
    args: [getBlobIdRecord(blobId)]
  });

/* **** GET **** /blobs-library */
export const getAllBlobs = async (pagination: Pagination, search: string) =>
  sendRequest<GETBlobsResponse, null>(getBlobsAPI, {
    queryStringParams: [{ key: 'name', value: search }, ...transformPaginationToSearchParams(pagination)]
  });

/* **** GET **** /blobs-library/:blobId */
export const getSingleBlob = async (blobId: UUID) =>
  sendRequest<GETSingleBlobResponse, null>(getSingleBlobAPI, {
    args: [getBlobIdRecord(blobId)]
  });

/* **** GET **** /media-library */
export const getAllMediaFiles = async (mediaType: MediaBlobType | 'ALL', pagination: Pagination, search: string) =>
  sendRequest<GETMediaFilesResponse, null>(getMediaFilesAPI, {
    queryStringParams:
      mediaType !== 'ALL'
        ? [
            { key: 'fileType', value: mediaType },
            { key: 'name', value: search },
            ...transformPaginationToSearchParams(pagination)
          ]
        : [{ key: 'name', value: search }, ...transformPaginationToSearchParams(pagination)]
  });

/* **** PUT **** /progress/:mymeId/:moduleId/:blobId */
export const updateBlobProgress = async (
  mymeId: string,
  blobId: string,
  progress: PUTUpdateBlobProgressBody,
  moduleId: string
) =>
  sendRequest<PUTUpdateBlobProgressResponse, PUTUpdateBlobProgressBody>(updateBlobProgressAPI, {
    args: [
      { key: 'mymeId', value: mymeId },
      { key: 'blobId', value: blobId },
      { key: 'moduleId', value: moduleId }
    ],
    reqBody: progress
  });
